import {instance, requestPromiseWrapper, requestWithSpinnerNoAlertErrorsPromiseWrapper} from "./instance";

export function getCompanySettingsRequest() {
  return requestPromiseWrapper(instance.get("/company-settings/"));
}

export function updateCompanySettingsRequest(newSettingsInfo) {
  return requestWithSpinnerNoAlertErrorsPromiseWrapper(instance.put("/company-settings/", newSettingsInfo));
}